import { FC } from 'react';
// component
import EditIngredientComponent from 'components/main/Ingredients/Edit';

const EditIngredient: FC = () => <EditIngredientComponent />;

export default EditIngredient;
